export default __webpack_public_path__ + "static/media/pic2.c09034c0.jpg";